'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangeconfirmationController', ProductchangeconfirmationController);

function ProductchangeconfirmationController($scope, $routeParams, dialogData, sessionData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 3 });

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeConfirmation,
            product.texts.headerSubTitleProductChangeConfirmation,
            product.images.headerImageChangeConfirmationResourcePath);

        htmlTruster.trust(data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('productchange_confirmation', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: 1,
            shop_product_sku: $routeParams.subscriptionTemplateId,
            shop_product_status: "conf",
            shop_order_value: sessionData.transient.priceValue,
            shop_order_id: $routeParams.uniqueSubscriptionId
        });

        sessionData.transient.priceValue = undefined;
    }

    initDialogData();
}